export const Formats = {
  date: {
    'es-ES': 'dd/MM/yyyy',
    'pt-PT': 'dd/MM/yyyy',
    'en-GB': 'MM/dd/yyyy',
  },
  currency: {
    'es-ES': { digits: '1.2-2', code: 'EUR', locale: 'es-ES' },
    'pt-PT': { digits: '1.2-2', code: 'EUR', locale: 'pt-PT' },
    'en-GB': { digits: '1.2-2', code: 'GBP', locale: 'en-GB' }
  }
};
